export interface LinkConfiguration {
    visible: boolean;
    href: string;
}

const emptyLink: LinkConfiguration = { visible: false, href: '' }

export { emptyLink };
